module.exports = __webpack_public_path__ + "static/media/enter.7d7755ec.svg";